import { Component, OnInit, EventEmitter, ViewChild ,Input} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { DatePickerGlobalOptions, serviceConstants } from 'src/app/constants/service.constants';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { AttachmentClassificationComponent } from 'src/app/common/attachment-classification/attachment-classification.component';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { UserService } from '../../../../services/user.service';
import { DatePipe } from '@angular/common';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { CommonService } from '../../../../services/common.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { EditOthersRenderer } from 'src/app/common/client-grid/edit-others-operations.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ist-amendments-view-modal',
  templateUrl: './ist-amendments-view-modal.component.html',
  styleUrls: ['./ist-amendments-view-modal.component.scss']
})
export class IstAmendmentsViewModalComponent implements OnInit {

  // File upload
  @Input() public Content: any;
  RequiredSettings: boolean = true;
  formData: FormData;
  amdTypeOptions = [];
  PatientList = [];
  amemdmentsForm: UntypedFormGroup;
  columnDefs;
  gridApi: GridApi;
  rowData;
  context;
  gridOptions;
  frameworkComponents;
  loadGrid = false;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  ApplicationID: any;
  userType: string = "";
  amendment: any;
  appstatus:boolean;
  myDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate();
  operations: any[] = [];
  Attachments: any[] = [];
  staticformFields:any;

  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  selectedRow: any;
  TempOperations: { name: string; id: string; }[];
  tempoperations: any;

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private userService: UserService,
    public datepipe: DatePipe,
    public commonService: CommonService
  ) { }

  ngOnInit() {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.getStaticFiledsData('SCR-012');
    this.rowData = [];
   this.appstatus= this.commonService.getIstStatus();
 
    if (this.Content.heading === 'Add') { //Add mode 
      this.Content.content.id = this.commonService.getUniqueId();
    }
    this.userType = this.userService.getUserType();
    this.amemdmentsForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      APPLICATION_ID: new UntypedFormControl(""),
      TYPE: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      PATIENT_ID: new UntypedFormControl(null),
      NOTES: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(0),
      Attachments: new UntypedFormControl("")
    });
    this.GetMasterDropdownData();

    this.TempOperations = [];

    if (this.Content.heading === 'Edit') { // Edit mode
      this.getRecordFprEdit();

    }
    else if (this.Content.heading === 'View') { //View mode 
      this.getRecordFprEdit();
      this.amemdmentsForm.disable();
    }
    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,
      IsScreenGrid: true,
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }

    this.columnDefs = [
      {
        "headerName": "Attachment Classification",
        "field": "AttachmentClassification"
      },
      {
        "headerName": "File Name",
        "field": "FileName"
      },
      {
        "headerName": "Date",
        "field": "Date"
      },
      {
        headerName: "",
        field: "value",
        cellRenderer: "editOthersRenderer",
        colId: "params",
        width: 50,
        sortable: false,
        cellStyle: { "overflow": 'visible' }
      }

    ];
    this.context = { componentParent: this };
    this.frameworkComponents = {
      editOthersRenderer: EditOthersRenderer
    };

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
  }

  deleteRow() {

  }

  GetMasterDropdownData() {
    this.summaryService.getScreenDataForEdit("api/ISTAmendments/GetMasterDropdownData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.Content.content.id).subscribe(result => {
      this.amdTypeOptions = result["MasterData1"];
      this.amdTypeOptions = [{ label: "Select", value: "", checked: true }].concat(this.amdTypeOptions);
      this.PatientList = result["MasterData2"];
    });

  }
  getRecordFprEdit() {
    this.summaryService.getScreenDataForEdit("api/ISTAmendments/Edit?RecordID=" + this.Content.content.id).subscribe(result => {
      if (result["SUBMISSION_DATE"] != null && result["SUBMISSION_DATE"] != "") {
        var formd2 = this.datepipe.transform(result["SUBMISSION_DATE"], 'dd-MMM-yyyy');
        result["SUBMISSION_DATE"] = formd2;
      }
      this.amemdmentsForm.patchValue({
        ID: result["ID"],
        APPLICATION_ID: result["ApplicationID"],
        TYPE: result["Type"],
        TITLE: result["Title"],
        PATIENT_ID: result["PATIENT_ID"],
        NOTES: result["Notes"],
        STATUS: result["Status"],
      });
      this.rowData = result["Attachments"];
      this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
      if (this.amemdmentsForm.controls["STATUS"].value == '2') { // Edit mode
        this.amemdmentsForm.disable();
        this.Content.heading = "View";
      }

      this.extendedForm.rowid = result["ID"];
      this.extendedForm.getResponse();
    });

  }


  SaveAmendments() {
    if (this.validateControls()) {
      var formData = this.amemdmentsForm.value;
      formData["APPLICATION_ID"] = this.ApplicationID;
      //if (formData["SUBMISSION_DATE"] != null && formData["SUBMISSION_DATE"] != "") {
      //  formData["SUBMISSION_DATE"] = new Date(formData["SUBMISSION_DATE"]);
      //  const ldate = new Date(formData["SUBMISSION_DATE"]);
      //  formData["STR_SUBMISSION_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();

      //}
      // formData["Attachments"] = { fileName: this.rowData["FileName"], fileId: this.rowData["FileID"]};

      this.rowData.forEach(element => {
        element["Operations"] = [];
      });

      formData["Attachments"] = this.rowData;

      if (this.Content.heading == "Add") {
        formData["ID"] = this.Content.content.id;
        formData.TITLE = formData.TITLE==null?null:formData.TITLE==undefined?undefined:formData.TITLE.trim();
        formData.NOTES = formData.NOTES==null?null:formData.NOTES==undefined?undefined:formData.NOTES.trim();
        this.summaryService.Insert("api/ISTAmendments/Insert", formData).subscribe(result => {
          if (result.Status == 0) {
            this.amemdmentsForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.Status == 0) 
              {
                this.commonService.SuccessBanner("Amendment " + "'" + formData["TITLE"] + "'" + " Added/Submitted successfully");
                 this.modalRef.close(formData);
              }
              else
              {
                this.commonService.ErrorBanner(result1.Message);
              }
            });
          }
          else 
          {
            this.commonService.ErrorBanner(result.Message);
          }
        });
      }
      else {
        formData.TITLE = formData.TITLE==null?null:formData.TITLE==undefined?undefined:formData.TITLE.trim();
        formData.NOTES = formData.NOTES==null?null:formData.NOTES==undefined?undefined:formData.NOTES.trim();
        this.summaryService.Insert("api/ISTAmendments/Update", formData).subscribe(result => {
          if (result.Status == 0 || result.ErrorCode == "NOCHANGES")
          {
            this.amemdmentsForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode == "NOCONTROLS")
              {
                if (result.Status == 0)
                {
                  this.commonService.SuccessBanner("Amendment " + "'" + formData["TITLE"] + "'" + " details updated successfully");
                  this.modalRef.close(formData);
                }
                else{
                  this.commonService.ValidationBanner(result.Message);
                }
              }
              else
              {
                if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner("Amendment " + "'" + formData["TITLE"] + "'" + " details updated successfully");
                  this.modalRef.close(formData);
                }
              }
            });
          }
          else 
          {
            this.commonService.ValidationBanner(result.Message);

            // this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
            //   if (result1.ErrorCode == "NOCONTROLS" && result.ErrorCode == "NOCHANGES") {
            //     this.commonService.ValidationBanner(result.Message);
            //   }
            //   else {
            //     if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
            //       this.commonService.ValidationBanner(result.Message);
            //     }
            //     else {
            //       this.commonService.SuccessBanner("Amendment " + formData["TITLE"] + " details updated successfully");
            //       //this.action.next(formData);
            //       this.modalRef.close(formData);
            //     }
            //   }
            // });


          }
        });
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.amemdmentsForm.value;

    if(this.staticformFields?.TYPE.IS_MANDATORY && this.staticformFields?.TYPE.IS_Display){
      if (formData.TYPE === null || formData.TYPE === "") {
        $("#TYPE").addClass("ng-touched ng-invalid validate-error");
        $("#TYPE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.TYPE.LABEL_NAME} <br/>`
        isValid = false;
      } else {
        $("#TYPE").addClass("ng-untouched ng-valid");
        $("#TYPE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

  if(this.staticformFields?.TITLE.IS_MANDATORY && this.staticformFields?.TITLE.IS_Display){
    if (formData.TITLE === null || formData.TITLE === ""||formData.TITLE=== undefined) {
      $("#TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#TITLE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.TITLE.LABEL_NAME} <br/>`
      isValid = false;
    } else if(formData.TITLE != null && formData.TITLE != undefined && formData.TITLE.trim()==""){
      $("#TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#TITLE").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.TITLE.LABEL_NAME} <br/>`
      isValid = false;
    } 
    else {
      $("#TITLE").addClass("ng-untouched ng-valid");
      $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
    }
  }

  if(this.staticformFields?.NOTES.IS_MANDATORY && this.staticformFields?.NOTES.IS_Display){
    if (formData.NOTES === null || formData.NOTES === ""||formData.NOTES === undefined) {
      $("#NOTES").addClass("ng-touched ng-invalid validate-error");
      $("#NOTES").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.NOTES.LABEL_NAME} <br/>`
      isValid = false;
    } else if(formData.NOTES != null && formData.NOTES != undefined && formData.NOTES.trim()==""){
      $("#NOTES").addClass("ng-touched ng-invalid validate-error");
      $("#NOTES").removeClass("ng-untouched ng-valid");
      message += `Please enter ${this.staticformFields?.NOTES.LABEL_NAME} <br/>`
      isValid = false;
    } 
    else {
      $("#NOTES").addClass("ng-untouched ng-valid");
      $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
    }
  }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + this.extendedForm.validateControlsMsgs();
      isValid = false;
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);

    return isValid;
  }

  SubmitRecord() {
    if (this.validateControls()) {
      var formData = this.amemdmentsForm.value;
      formData["APPLICATION_ID"] = this.ApplicationID;
      formData["STATUS"] = 2;
      this.rowData.forEach(element => {
        element["Operations"] = [];
      });
      formData["Attachments"] = this.rowData;
      if (this.Content.heading == "Add")
      {
        formData["ID"] = this.Content.content.id;
        this.summaryService.Insert("api/ISTAmendments/Insert", formData).subscribe(result => {
          if (result.Status == 0) 
          {
            this.amemdmentsForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.Status == 0) 
              {
                this.commonService.SuccessBanner("Amendment " + "'" + formData["TITLE"] + "'" + " added/submitted  successfully");
                this.modalRef.close(formData);
              }
              else
              {
                this.commonService.ErrorBanner(result1.Message);
              }
            });
          } 
          else
          {
            this.commonService.ErrorBanner(result.Message);
          }

        });
      }
      else {
        this.summaryService.Insert("api/ISTAmendments/Update", formData).subscribe(result => {
          if (result.Status == 0 || result.ErrorCode == "NOCHANGES")
          {
            this.amemdmentsForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode == "NOCONTROLS") 
              {
                if(result.Status == 0)
                {
                  this.commonService.SuccessBanner("Amendment " + "'" + formData["TITLE"] + "'" + " details submitted successfully");
                  this.modalRef.close(formData);
                }
                else
                {
                  this.commonService.ValidationBanner(result.Message);
                }
              }
              else
              {
                if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") 
                {
                  this.commonService.ValidationBanner(result.Message);
                }
                else
                {
                  this.commonService.SuccessBanner("Amendment " + "'" + formData["TITLE"] + "'" + " details submitted successfully");
                  this.modalRef.close(formData);
                }
              }
            });
          } 
          else
          {
            this.commonService.ValidationBanner(result.Message);

            // this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
            //   if (result1.ErrorCode == "NOCONTROLS" && result.ErrorCode == "NOCHANGES") {
            //     this.commonService.ValidationBanner(result.Message);
            //   }
            //   else {
            //     if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
            //       this.commonService.ValidationBanner(result.Message);
            //     }
            //     else {
            //       this.commonService.SuccessBanner("Amendment " + formData["TITLE"] + " details submitted successfully");
            //       this.modalRef.close(formData);
            //     }
            //   }
            // });

          }
        });
      }
    }
  }


  onRowDoubleClicked(event) {
  }
  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  getAttachmentsData() {

    this.summaryService.getSummaryData("api/ISTFileAttachments/getScreenAttachments?TransactionID=" + 1).subscribe((result) => {
      this.rowData = result;
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 350);
    });


  }

  addNewAttachment() {
    let modalRef = this.modalService.open(AttachmentClassificationComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      screencode:"SCR-012",
      is_ac_display:this.staticformFields.Amendment_AC.IS_Display,
      is_ac_mand:this.staticformFields.Amendment_AC.IS_MANDATORY,
      ac_label:this.staticformFields.Amendment_AC.LABEL_NAME,
      is_file_display:this.staticformFields.Amendment_CF.IS_Display,
      is_file_mand:this.staticformFields.Amendment_CF.IS_MANDATORY,
      file_lable:this.staticformFields.Amendment_CF.LABEL_NAME,
      file_subLabel:this.staticformFields.Amendment_CF.SUB_LABEL,
      is_multiple_files:this.staticformFields.Amendment_CF.IS_MULTISELECT,
      PURPOSE:this.staticformFields.Amendment_CF.PURPOSE,
      content: { id: "", ModuleName: "IST", ScreenName: 'Amendments', filesList: this.rowData }
    }
    modalRef.result.then(result => {
      this.loadGrid = false;
      result.forEach((item: any) => {
        this.rowData.push(item);
      });
      this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
    })

  }

  setOperations(RawData: any): any {
    let tempOperations;
    if (this.Content.heading == 'Edit') {
      tempOperations = [
        {
          "name": "Delete",
          "id": "Delete"
        },
        {
          "name": "Download",
          "id": "Download"
        },
        {
          "name": "Preview",
          "id": "ViewFile"
        }
      ];
    }

    if (this.Content.heading == 'View') {
      tempOperations = [
        {
          "name": "Download",
          "id": "Download"
        },
        {
          "name": "Preview",
          "id": "ViewFile"
        }
      ];
    }
    if (this.Content.heading == "Add") {

      tempOperations = [
        {
          "name": "Delete",
          "id": "Delete"
        }
      ];
    }

    this.setDef(tempOperations);
    RawData.forEach(element => {
      if (element.Status == "Add" && this.Content.heading == 'Edit') {
        this.TempOperations = [];
        this.TempOperations.push(
          {
            "name": "Delete",
            "id": "Delete"
          }
        );
        element["Operations"] = this.setDef(this.TempOperations);
      } else {
        element["Operations"] = this.setDef(tempOperations);
      }

      if(element.FileID == null){
        this.TempOperations = [];
        this.TempOperations.push(
          {
            "name": "Delete",
            "id": "Delete"
          }
        );
        element["Operations"] = this.setDef(this.TempOperations);
      }
    });
    return RawData;
  }

  setDef(parmoperations: any): any {

    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }


  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onOperationClick(opr) {
    opr.callback();
  }


  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  Download() {
    let fileID = this['self'].selectedRow['FileID'];
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile() {
    let fileID = this['self'].selectedRow['FileID'];
    let fileName = this['self'].selectedRow['FileName'];
    this['self'].commonService.previewFile(fileID, fileName, "med");
  }

  Delete() {
    let fileID = this['self'].selectedRow['FileID'];
    let fileName = this['self'].selectedRow['FileName'];
    this['self'].commonService.CheckIsFileIsRefereancedInReviw(fileID).subscribe((x)=>{
      if(x["Status"]==2 && x["Data"]==false)
      {
        this.commonService.ValidationBanner(x["Message"]);
      }
      else{
        let className =  this['self'].selectedRow['AttachmentClassification'];
        let modalRef = this["self"].modalService.open(DeleteBoxComponent,  { backdrop: false });
        if(fileName != null){
          modalRef.componentInstance.Content=  { heading: '', custommessage: 'Are you sure you want to delete the ' + "'" + fileName + "'" + '?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };
        }else{
        modalRef.componentInstance.Content=  { heading: '', custommessage: 'Are you sure you want to delete the ' + "'" + className + "'" + '?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };
    
        }
    
        modalRef.result.then(result => {
          if (result == 'okclick') {
            // this['self'].summaryService.DeleteRecord("api/ISTFileAttachments/DeleteAmendFile?FileID=" + fileID).subscribe(summary => {
            //   if (summary["Status"] == 0) {
            //     this.getAttachmentsData();          
            //   }  
            // });
            let index = this['self'].rowData.findIndex(x => x.FileID == fileID);
            if (index != null) {
              this['self'].rowData.splice(index, 1);
              this['self'].loadGrid = false;
              setTimeout(() => {
                this['self'].loadGrid = true;
                document.body.click();
              }, 300);
            }
          }
        });
      }
  });
  }

  getStaticFiledsData(screenCode:string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }
}
